import React from 'react';
import { useSelector } from 'react-redux';
import T from 'prop-types';
import { times } from 'lodash-es';

import AppIcon from '../../../../components/AppIcon';
import Skeleton from '../../../../components/Skeleton';
import DashboardStickyHeader from '../../_shared/components/DashboardStickyHeader';
import { DashboardTabNavigationDropdown } from '../../_shared/components/DashboardTabNavigation';
import useDashboardNav, { scrollToSection } from '../../_shared/hooks/useDashboardNav';
import { aiDashboardAppsSelector } from '../selectors';
import { SECTIONS, SECTIONS_IDS } from '../configs/sections';

const AiStickyHeader = ({ stickySentinelRef }) => {
  const apps = useSelector(aiDashboardAppsSelector);

  const { active, isSticky } = useDashboardNav(SECTIONS, stickySentinelRef);

  const showTopApps = active.id !== SECTIONS_IDS.marketOverview;
  const visibleApps = (showTopApps ? apps.data?.top_apps : apps.data?.apps) || [];

  return (
    <DashboardStickyHeader
      headerLeft={
        <>
          <span className="eyebrow">Gen AI App Insights</span>
          <DashboardTabNavigationDropdown
            active={active}
            sections={SECTIONS}
            onScrollToSection={scrollToSection}
          />
        </>
      }
      headerRight={
        <div key={showTopApps ? 'top' : 'all'} className="dashboard-sticky-header__apps">
          {apps.settings.pending
            ? times(5).map((i) => <Skeleton key={i} height={32} width={32} />)
            : visibleApps.map((app) => (
                <AppIcon
                  key={app.ref_no}
                  url={app.icon_url}
                  store={app.store}
                  size={32}
                  alt={app.nickname}
                  withBorder
                />
              ))}
        </div>
      }
      isSticky={isSticky}
    />
  );
};

AiStickyHeader.propTypes = {
  stickySentinelRef: T.shape({ current: T.instanceOf(Element) }).isRequired,
};

export default AiStickyHeader;
